
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import {
  validateChildrenComponentForms,
  getAPIAuthorizedHeader,
} from "@/services/common";
import { BankDetail } from "@/models/bank";

@Component({})
export default class SignUpComponent extends Vue {
  public bankDetail = new BankDetail();
  public editing = false;
  public disableSubmitbutton = false

  cancelForm() {
    this.$router.go(-1);
  }

  public async saveInformation() {
      this.disableSubmitbutton = true;
      this.$showLoader(true);
      /**
       * This will execute the validateAll fuction in all the child component
       * returning the state of validation whether it is valid or invalid
       */
      let childrensValid = await validateChildrenComponentForms(this.$children);
      let formValid = await this.$validator.validateAll();

      if (!formValid || !childrensValid) {
        this.disableSubmitbutton = false;
        this.$showLoader(false);
        return { status: false };
      }
      let response = await Axios.post(
        API_STORE.ADMIN + "updateBankDetail",
        this.bankDetail,
        { headers: getAPIAuthorizedHeader() }
      );
      this.disableSubmitbutton = false;
      this.$showLoader(false);
      if (response) { this.$snotify.success(response.data.message);
      this.$router.push("/superAdmin/banksDetail");
      }
  }

  public async getBankDetail(bankId) {
      let response = await Axios.get(API_STORE.ADMIN + "getBankDetail", {
        params: {
          bankId: bankId,
          subdomain: this.$client ? this.$client.subdomain : null,
        },
        headers: getAPIAuthorizedHeader(),
      });
      if (response) this.bankDetail = response.data.bankDetail;
  }

  mounted() {
    this.bankDetail.subdomain = this.$client ? this.$client.subdomain : null;
    this.editing = this.$route.query.bankId ? true : false;
    if (this.$route.query.bankId) {
      this.getBankDetail(this.$route.query.bankId);
    }
  }
}
